function env(key: string): string | undefined {
  const value = import.meta.env[key] as string | undefined;
  const trimmed = value?.trim();
  return trimmed ? trimmed.replace(/\/+$/, "") : undefined;
}

const APP_BASE = env("VITE_APP_URL") ?? "https://app.cronika.com";
const AFFILIATE_BASE = env("VITE_AFFILIATE_URL") ?? "https://affiliate.cronika.com";

export const API_BASE_URL = env("VITE_API_URL") ?? "https://api.cronika.com";

export const appUrl = (path: string, lang = "en") => `${APP_BASE}/${lang}/${path.replace(/^\//, "")}`;

export const links = {
  appBase: APP_BASE,
  affiliateBase: AFFILIATE_BASE,
  register: `${AFFILIATE_BASE}/sign-up`,
  login: `https://partner.cronikaffiliate.com/login`,
  dashboard: `${AFFILIATE_BASE}/dashboard`,
  supportEmail: "mailto:support@cronika.com",
  contact: {
    telegramManager: "https://t.me/cronika_dan",
    telegramManagerHandle: "@cronika_dan",
    email: "mailto:affiliate@cronikaffiliate.com",
    emailHandle: "affiliate@cronikaffiliate.com",
    telegramChannelRu: "https://t.me/+wDQWWOhtv0lhNDBi",
    telegramChannelEn: "https://t.me/+wDQWWOhtv0lhNDBi",
  },
  social: {
    x: "https://x.com/cronikaofficial?s=21&t=CliTNduKk2naPUyuNhjonA",
    instagram: "https://www.instagram.com/cronikaofficial?igsh=NTNxa2dtN2YxNXgy",
    tiktok: "https://www.tiktok.com/@cronikamain?_t=ZM-8zPplj1PBaw&_r=1",
  },
  legal: {
    privacy: "https://cronika.com/documents/privacy-policy",
    terms: "https://cronika.com/documents/user-agreement",
    partnership: "https://cronika.com/documents/partnership-agreement",
  },
} as const;
